/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


$('.quick_add').on("click", function(){ 
  var ID = $(this).attr("data-var_id");
  $(this).addClass(".PageOverlay.is-visible");
  addItemToCart( ID, 1);  
  setTimeout(function(){
    $('#sidebar-cart').attr("aria-hidden","false");
  }, 1500);
  $(document).on("click", '.Drawer__Close', function(){
    $('#sidebar-cart').attr("aria-hidden","true");      
  });
  $(document).on("click", '#cartdrawer_close', function(){
    $('#sidebar-cart').attr("aria-hidden","true");      
  });
});
function addItemToCart(variant_id, qty) {
  data = {
    "id": variant_id,
    "quantity": qty
  }
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function() { 
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true 
      }));
    }    
  });  
}

// FAQ START
$('.Faq__Item').on('click', function () {
  var $this = $(this);
  var $answerWrapper = $this.find(".Faq__AnswerWrapper");

  if ($this.attr("aria-expanded") === 'true') {
    $this.attr("aria-expanded", "false");
    $answerWrapper.attr("aria-hidden", "true").css('height', '0px');
    return;
  }

  // expand current
  $this.attr("aria-expanded", "true");
  $answerWrapper.attr("aria-hidden", "false").css('height', 'auto')

  // collapse all others
  $('.Faq__Item[aria-expanded="true"]').not(this).each(function () {
    var $sibling = $(this);
    var $siblingAnswerWrapper = $sibling.find(".Faq__AnswerWrapper");
    $sibling.attr("aria-expanded", "false");
    $siblingAnswerWrapper.attr("aria-hidden", "true").css('height', '0px');
  });
});
// FAQ END
